import type { OrderConversion } from '@consumer/types/serializers'
import { track as trackMetaPixel } from '@consumer/services/metaPixel'

declare global {
  interface Window {
    uetq?: any[]
  }
}

// itemId is the Merchant Center feed offer_id resolved server-side against the
// place's live feed products (see Place#feed_offer_id) so dynamic remarketing
// gets a 1:1 match. It's null when the place isn't in the feed — skip then.
function remarketingItem (itemId: string, itemName: string, amount: number) {
  return { item_id: itemId, item_name: itemName, price: amount, currency: 'USD', quantity: 1 }
}

export function trackViewItem (itemId: string | null | undefined, itemName: string, amount: number) {
  if (!itemId) return

  window.gtag('event', 'view_item', {
    currency: 'USD',
    value: amount,
    items: [remarketingItem(itemId, itemName, amount)],
  })
}

export function trackAddToCart (itemId: string | null | undefined, itemName: string, amount: number) {
  if (!itemId) return

  window.gtag('event', 'add_to_cart', {
    currency: 'USD',
    value: amount,
    items: [remarketingItem(itemId, itemName, amount)],
  })
}

export function trackPurchaseConversion (order: OrderConversion) {
  trackBingConversion(order)
  const gifts = order.gifts
    .filter(orderGift => orderGift.feedItemId)
    .map((orderGift) => {
      return {
        item_id: orderGift.feedItemId,
        item_name: orderGift.placeName,
        item_category2: orderGift.category,
        item_category3: orderGift.subCategory,
        price: orderGift.amount,
        currency: 'USD',
        quantity: '1',
      }
    })
  // And to Google Analytics 4
  const purchaseEvent: Record<string, any> = {
    transaction_id: order.orderNumber,
    affiliation: order.purchaseMethod,
    value: order.totalGiftAmount,
    shipping: '0',
    tax: order.totalFees,
    currency: 'USD',
    new_customer: order.newCustomer,
  }
  if (gifts.length) purchaseEvent.items = gifts
  window.gtag('event', 'purchase', purchaseEvent)

  // google ads conversions tracking
  window.gtag('event', 'conversion', {
    send_to: 'AW-860469268/q_tPCJ32oaAZEJTwppoD',
    value: order.originalOrderTotal,
    currency: 'USD',
    transaction_id: order.orderNumber,
    new_customer: order.newCustomer,
  })

  // google ads revenue conversions tracking
  window.gtag('event', 'conversion', {
    send_to: 'AW-860469268/GOzLCNH4pbIZEJTwppoD',
    value: order.netRevenue,
    currency: 'USD',
    transaction_id: order.orderNumber,
    new_customer: order.newCustomer,
  })

  // track purchases in Meta pixel https://www.facebook.com/business/help/402791146561655?id=1205376682832142
  const purchasePayload: Record<string, any> = {
    value: order.originalOrderTotal,
    currency: 'USD',
    transaction_id: order.orderNumber,
    num_items: order.gifts.length,
  }
  if (order.metaPixelContentId) {
    purchasePayload.content_ids = [order.metaPixelContentId]
    purchasePayload.content_type = 'product'
  }
  trackMetaPixel('Purchase', purchasePayload)
}

function trackBingConversion (order: OrderConversion) {
  window.uetq ||= []
  window.uetq.push('event', 'purchase', { revenue_value: order.totalGiftAmount, currency: 'USD' })
}
